import moment from 'moment';

export const getTimestamp = (ts) => {

    console.log('ts', ts)
  let _ts = new Date(ts*1000);
  return moment(ts).fromNow()
  // return moment(_ts).format('MM-DD HH:mm:ss')
}

export const getTimestamp2 = (ts) => {
  const now = moment();
  const time = moment.unix(Math.floor(ts / 1000)); // Convert milliseconds to seconds

  const diffSeconds = now.diff(time, 'seconds');
  if (diffSeconds < 60) return `${diffSeconds}s`;

  const diffMinutes = now.diff(time, 'minutes');
  if (diffMinutes < 60) return `${diffMinutes}m`;

  const diffHours = now.diff(time, 'hours');
  if (diffHours < 24) return `${diffHours}h`;

  const diffDays = now.diff(time, 'days');
  return `${diffDays}d`;
};

export const formatAddress = (address) => {
    if (!address) {
        return 'unknown';
    }
    return address?.toString()?.substring(0, 4) + '...' + address?.toString()?.substring(address.length - 4).toLowerCase();
}

export const formatAddress2 = (address) => {
    if (!address) {
        return 'unknown';
    }
    return address?.toString()?.substring(0, 0) + '..' + address?.toString()?.substring(address.length - 4).toLowerCase();
}

export const removeEmojis = (string) => {
    var regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
    return string.replace(regex, '');
}

export const trimName = (name, maxLength = 20) => {
  return name.length > maxLength ? name.slice(0, maxLength) + "..." : name;
};

export const getTimestamp3 = (ts) => {
  const now = moment();
  const time = moment(ts); // Directly parse ISO timestamp

  const diffSeconds = now.diff(time, 'seconds');
  if (diffSeconds < 60) return `${diffSeconds}s`;

  const diffMinutes = now.diff(time, 'minutes');
  if (diffMinutes < 60) return `${diffMinutes}m`;

  const diffHours = now.diff(time, 'hours');
  if (diffHours < 24) return `${diffHours}h`;

  const diffDays = now.diff(time, 'days');
  return `${diffDays}d`;
};
